module.exports = __webpack_public_path__ + "static/img/069_TO8_1692_og.c51d768.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/069_TO8_1692_og.jpg
// module id = P6zh
// module chunks = 0